import {configure, defineRule} from 'vee-validate';
import {localize} from "@vee-validate/i18n";
import en from '@vee-validate/i18n/dist/locale/en.json';
import AllRules from '@vee-validate/rules';

configure({
    generateMessage: localize('en', en),
    validateOnInput: true,
});

Object.keys(AllRules).forEach(rule => {
    defineRule(rule, AllRules[rule]);
});

defineRule('digits_without_whitespace', (value, [target], input) => {
    if (!value || value.replace(/ /g, '').length <= parseInt(target)) return true

    return `The ${input.field} field must be numeric and exactly contain ${target} digits`;
});

defineRule('uri_safe', (value, [target], input) => {
    //https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

    if (pattern.test(value)) return true

    return `The ${input.field} is not valid.`;
});

defineRule('decimal', (value, [target], input) => {
    let decimal_available = value && value.toString().split('.').length > 1;
    if (!value || value.toString().split('.').length === 1 ||
        (decimal_available && value.toString().split('.')[1].toString().length <= 2)) return true

    return `The ${input.field} field must be numeric and may contain ${target} decimal points`;
});

